import styled, { css } from "styled-components";
import { pxToRem } from "styles/utils";

export const PageWrapper = styled.div<{ bottomOffset?: number }>`
  /* bottomOffset приходит от Telegram в физических пикселях. */
  min-height: calc(100vh + ${(props) => props.bottomOffset || 50}px);
  justify-content: space-between;
  background: radial-gradient(
      51% 51% at 50% 121%,
      rgba(131, 102, 228, 0.6),
      rgba(131, 102, 228, 0)
    ),
    rgb(247, 248, 248);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  width: 100%;
  padding-bottom: ${(props) => props.bottomOffset || 50}px;
`;

export const LidHeader = styled.h2`
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(29)};
  font-weight: 700;
  margin: 0;
  margin-top: ${pxToRem(20)};
`;

export const FormTitle = styled.h2`
  display: flex;
  color: rgb(20, 20, 20);
  font-size: ${pxToRem(28)};
  font-weight: 600;
  margin: 0;
`;

export const Input = styled.input<{ hasError?: boolean }>`
  padding: 12px 16px;
  width: 100%;
  font-size: 16px;
  line-height: 1.25;
  border-radius: 10px;
  border: 1px solid rgba(31, 10, 53, 0.1);
  background: rgb(247, 248, 248);
  scrollbar-width: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.inkMuted};
    opacity: 1;
  }

  ${({ hasError }) =>
    hasError &&
    css`
      border: 1px solid rgb(242, 40, 98);
      background: rgba(114, 82, 220, 0.15);
    `}

  &:focus {
    border: 1px solid rgb(114, 82, 220);
    background: rgba(114, 82, 220, 0.15);
  }
`;

export const FormFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(16)};
  width: 100%;
  max-width: ${pxToRem(560)};
  padding: 0 ${pxToRem(20)};

  input {
    min-height: 44px;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.25;
    color: ${({ theme }) => theme.colors.ink};
  }

  input::placeholder {
    color: ${({ theme }) => theme.colors.inkMuted};
    opacity: 1;
  }

  li {
    font-size: 16px;
    line-height: 1.25;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: ${pxToRem(560)};
  margin-top: ${pxToRem(20)};
  margin-bottom: ${pxToRem(50)};
  padding: 0 ${pxToRem(20)};

  button {
    height: 44px;
    font-size: 16px;
  }

  button:disabled {
    opacity: 0.5;
  }
`;
